class StoreLocator {
  constructor() {
    this.map = null;
    this.markers = [];
    this.activeInfoWindow = null;
    this.stores = [];
    this.filteredStores = [];

    // Configuración de la API
    this.apiUrl = window.storeLocatorConfig.apiUrl;
    this.apiKey = window.storeLocatorConfig.apiKey;

    // Iconos
    this.icons = {
      adoc: {
        icon: "https://cdn.shopify.com/s/files/1/0346/1893/3307/files/logo_adoc-min.png?v=1655323909",
        scaledSize: new google.maps.Size(40, 40),
      },
    };

    this.init();
  }

  async init() {
    this.initMap();
    this.setupEventListeners();
    await this.loadStores();
  }

  initMap() {
    this.map = new google.maps.Map(document.getElementById("map"), {
      zoom: 12,
      center: { lat: 13.7063894, lng: -89.2124064 },
      mapId: "46642173f0d6b463",
      styles: [
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ],
    });

    // Intenta geolocalización
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.map.setCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });

          // Agregar marcador de ubicación actual
          new google.maps.Marker({
            position: {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            },
            map: this.map,
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 8,
              fillColor: "#4285F4",
              fillOpacity: 1,
              strokeColor: "white",
              strokeWeight: 2,
            },
            title: "Tu ubicación",
          });
        },
        () => {
          // Si falla la geolocalización, centrar en posición por defecto
          this.map.setCenter({ lat: 13.7063894, lng: -89.2124064 });
        }
      );
    }
  }

  async loadStores() {
    try {
      this.showLoading(true);

      const response = await fetch(
        `${this.apiUrl}/stores?select=*&is_active=eq.true`,
        {
          headers: {
            apikey: this.apiKey,
            Authorization: `Bearer ${this.apiKey}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al cargar las tiendas");
      }

      this.stores = await response.json();
      this.filteredStores = [...this.stores];

      this.renderStores();
      this.showLoading(false);
    } catch (error) {
      console.error("Error:", error);
      this.showLoading(false, true);
    }
  }

  renderStores() {
    // Limpiar marcadores existentes
    this.clearMarkers();

    // Limpiar lista de tiendas
    const storesList = document.getElementById("stores-list");
    storesList.innerHTML = "";

    if (this.filteredStores.length === 0) {
      storesList.innerHTML =
        '<div class="no-results">No se encontraron tiendas que coincidan con tu búsqueda.</div>';
      this.updateResultsCount(0);
      return;
    }

    // Crear marcadores y tarjetas
    this.filteredStores.forEach((store) => {
      const position = { lat: store.latitude, lng: store.longitude };

      // Crear marcador
      const marker = new google.maps.Marker({
        position: position,
        map: this.map,
        icon: this.icons.adoc.icon,
        title: store.place_name,
        storeId: store.id,
      });

      // Crear contenido del InfoWindow
      const infoWindowContent = this.createStoreInfoWindowContent(store);
      const infoWindow = new google.maps.InfoWindow({
        content: infoWindowContent,
      });

      // Evento click en el marcador
      marker.addListener("click", () => {
        this.handleMarkerClick(marker, infoWindow, store);
      });

      // Guardar referencia al marcador
      this.markers.push({
        marker: marker,
        store: store,
        infoWindow: infoWindow,
      });

      // Crear tarjeta de tienda en la lista
      const storeCard = document.createElement("div");
      storeCard.className = "store-card";
      storeCard.id = `store-${store.id}`;
      storeCard.innerHTML = this.createStoreCardContent(store);
      storeCard.addEventListener("click", () => {
        this.handleStoreCardClick(store, marker, infoWindow);
      });

      storesList.appendChild(storeCard);
    });

    // Ajustar vista del mapa para mostrar todos los marcadores
    this.fitMapToMarkers();

    // Actualizar contador
    this.updateResultsCount(this.filteredStores.length);
  }

  createStoreInfoWindowContent(store) {
    let content = `
        <div class="info-window">
          <h3 class="store-name">${store.place_name}</h3>
          <p class="store-address">${store.store_address}</p>
          <p class="store-schedule">${store.schedule}</p>
          <div class="store-actions">`;

    if (store.phone) {
      content += `
          <a href="tel:+503${store.phone}" class="store-action">
            <img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Teléfono">
            Llamar: (503) ${store.phone}
          </a>`;
    }

    content += `
          <a href="https://api.whatsapp.com/send?phone=503${store.whatsapp}" target="_blank" class="store-action">
            <img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="WhatsApp">
            WhatsApp: (503) ${store.whatsapp}
          </a>
          <a href="https://www.waze.com/ul?ll=${store.latitude},${store.longitude}&navigate=yes&zoom=17" target="_blank" class="store-action">
            <img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Waze">
            Navegar con Waze
          </a>`;

    if (store.page_url) {
      content += `
          <a href="${store.page_url}" target="_blank" class="store-action">
            <img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/map-marker-alt-solid.png?v=1643988824" alt="Mapa">
            Ver en mapa
          </a>`;
    }

    if (store.review_url) {
      content += `
          <a href="${store.review_url}" target="_blank" class="store-action review-button">
            Dejar reseña
          </a>`;
    }

    content += `
          </div>
        </div>`;

    return content;
  }

  createStoreCardContent(store) {
    let content = `
        <div class="store-name">${store.place_name}</div>
        <div class="store-address">${store.store_address}</div>
        <div class="store-schedule">${store.schedule}</div>
        <div class="store-contacts">`;

    if (store.phone) {
      content += `
          <a href="tel:+503${store.phone}" class="contact-button">
            <img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Teléfono">
            Llamar
          </a>`;
    }

    content += `
        <a href="https://api.whatsapp.com/send?phone=503${store.whatsapp}" target="_blank" class="contact-button">
          <img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="WhatsApp">
          WhatsApp
        </a>
        <a href="https://www.waze.com/ul?ll=${store.latitude},${store.longitude}&navigate=yes&zoom=17" target="_blank" class="contact-button">
          <img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Waze">
          Waze
        </a>`;

    if (store.page_url) {
      content += `
        <a href="${store.page_url}" target="_blank" class="contact-button">
          <img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/map-marker-alt-solid.png?v=1643988824" alt="Mapa">
          Mapa
        </a>`;
    }

    content += `</div>`;

    return content;
  }

  handleMarkerClick(marker, infoWindow, store) {
    if (this.activeInfoWindow) this.activeInfoWindow.close();

    infoWindow.open(this.map, marker);
    this.activeInfoWindow = infoWindow;
    this.highlightStoreCard(store.id);
  }

  handleStoreCardClick(store, marker, infoWindow) {
    this.map.panTo({ lat: store.latitude, lng: store.longitude });
    this.map.setZoom(16);

    if (this.activeInfoWindow) this.activeInfoWindow.close();

    infoWindow.open(this.map, marker);
    this.activeInfoWindow = infoWindow;
    this.highlightStoreCard(store.id);
  }

  highlightStoreCard(storeId) {
    document.querySelectorAll(".store-card").forEach((card) => {
      card.classList.remove("active");
    });

    const selectedCard = document.getElementById(`store-${storeId}`);
    if (selectedCard) {
      selectedCard.classList.add("active");
      selectedCard.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }

  filterStores(zone) {
    if (zone === "all") {
      this.filteredStores = [...this.stores];
    } else {
      this.filteredStores = this.stores.filter(
        (store) => store.zone === parseInt(zone)
      );
    }

    this.renderStores();
    this.updateActiveTab(zone);
  }

  searchStores() {
    const searchTerm = document
      .getElementById("store-search")
      .value.toLowerCase();

    this.filteredStores = this.stores.filter(
      (store) =>
        store.place_name.toLowerCase().includes(searchTerm) ||
        store.store_address.toLowerCase().includes(searchTerm)
    );

    this.renderStores();
  }

  clearMarkers() {
    this.markers.forEach((markerObj) => {
      markerObj.marker.setMap(null);
    });
    this.markers = [];
  }

  fitMapToMarkers() {
    if (this.filteredStores.length === 0) return;

    const bounds = new google.maps.LatLngBounds();
    this.filteredStores.forEach((store) => {
      bounds.extend({ lat: store.latitude, lng: store.longitude });
    });

    // Si solo hay un marcador, centrar y hacer zoom en lugar de ajustar límites
    if (this.filteredStores.length === 1) {
      this.map.setCenter(bounds.getCenter());
      this.map.setZoom(16);
    } else {
      this.map.fitBounds(bounds);
    }
  }

  updateResultsCount(count) {
    const countElement = document.getElementById("store-results-count");
    countElement.textContent = `${count} ${
      count === 1 ? "tienda encontrada" : "tiendas encontradas"
    }`;
  }

  updateActiveTab(zone) {
    document.querySelectorAll(".filter-tab").forEach((tab) => {
      tab.classList.remove("active");
    });

    const activeTab = document.querySelector(
      `.filter-tab[data-zone="${zone}"]`
    );
    if (activeTab) {
      activeTab.classList.add("active");
    }
  }

  showLoading(show, error = false) {
    const resultsCount = document.getElementById("store-results-count");

    if (error) {
      resultsCount.innerHTML =
        '<span style="color: #ff4444;">Error al cargar las tiendas. Intenta recargar la página.</span>';
      return;
    }

    if (show) {
      resultsCount.innerHTML = `
          <div class="loading-text">
            <div class="loader"></div>
            <span>Cargando tiendas...</span>
          </div>
        `;
    }
  }

  setupEventListeners() {
    // Botón de búsqueda
    document.getElementById("search-button").addEventListener("click", () => {
      this.searchStores();
    });

    // Búsqueda al presionar Enter
    document.getElementById("store-search").addEventListener("keyup", (e) => {
      if (e.key === "Enter") {
        this.searchStores();
      }
    });

    // Filtros por zona
    document.querySelectorAll(".filter-tab").forEach((tab) => {
      tab.addEventListener("click", () => {
        const zone = tab.dataset.zone;
        this.filterStores(zone);
      });
    });
  }
}

// Inicializar cuando el DOM esté listo y la API de Google Maps cargada
document.addEventListener("DOMContentLoaded", () => {
  if (typeof google !== "undefined") {
    new StoreLocator();
  } else {
    // Si Google Maps no está cargado, mostrar mensaje de error
    document.getElementById("store-results-count").innerHTML = `
        <span style="color: #ff4444;">
          Error: Google Maps no se ha cargado correctamente. Recarga la página.
        </span>
      `;
  }
});
